import React, { Component } from 'react'

import PropTypes from 'prop-types'

import LayoutElement from '../../../LayoutElement'

import { Container, Element, ElementsContainer } from './style'

const LAYOUT_ACCESSIBILITY_LABEL = 'Three column no hero layout'
const ELEMENTS_ACCESSIBILITY_LABEL = 'Layout elements container'

class OneThirdTwoThirdColumnNoHeroComponent extends Component {
  getElementComponent = (elementModules, index) => {
    const { getElementProps } = this.props
    const { elementProps, key, layoutElementProps } =
      getElementProps(elementModules, index) || {}

    return (
      <Element key={key} {...elementProps}>
        <LayoutElement {...layoutElementProps} />
      </Element>
    )
  }

  getElementComponents = () => {
    const { elements } = this.props
    const elementComponents = elements.map((elementModules, index) =>
      this.getElementComponent(elementModules, index),
    )

    return elementComponents
  }

  getRenderProps = () => {
    const { foregroundColor } = this.props
    const layoutElements = this.getElementComponents()
    const containerProps = {
      accessibilityLabel: LAYOUT_ACCESSIBILITY_LABEL,
    }
    const elementsContainerProps = {
      accessibilityLabel: ELEMENTS_ACCESSIBILITY_LABEL,
      foregroundColor,
    }
    const renderProps = {
      containerProps,
      elementsContainerProps,
      layoutElements,
    }

    return renderProps || {}
  }

  render = () => {
    const { containerProps, elementsContainerProps, layoutElements } =
      this.getRenderProps()

    return (
      <Container {...containerProps}>
        <ElementsContainer {...elementsContainerProps}>
          {layoutElements}
        </ElementsContainer>
      </Container>
    )
  }
}

OneThirdTwoThirdColumnNoHeroComponent.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
  foregroundColor: PropTypes.string,
  getElementProps: PropTypes.func,
}

OneThirdTwoThirdColumnNoHeroComponent.defaultProps = {
  elements: [],
  getElementProps() {},
}

export default OneThirdTwoThirdColumnNoHeroComponent
